import { MappedClass, MappedProperty, MappedPropertyArray } from '@h5s/util-object';
import { ZPrinterFiscalConfigVat } from './z-printer-fiscal-config-vat';

@MappedClass()
export class ZPrinterFiscalConfigVatListApplicable {
  @MappedProperty()
  is_applicable: boolean;

  @MappedProperty()
  read_only: boolean;

  @MappedPropertyArray(() => ZPrinterFiscalConfigVat)
  value: ZPrinterFiscalConfigVat[];
}
